import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import { ToastContainer, toast } from 'react-toastify';

import '../modals.css';

const AddToGroup = ( { close, aid, uid, viewing, allContacts, allLoans, lists, removeItem, aitl, cl, items, itemType } ) => {
    const [ search, setSearch ] = useState( '' );
    const [ glist, setGlist ] = useState( [] );
    const [ curLists, setCurLists ] = useState( [] );

    const filterGroup = ( e ) => {
        setSearch( e.target.value );
    };

    const add = async ( gid ) => {
        const g = lists[gid];
        await aitl( { aid: g.aid, uid: uid, gid: gid, items: items, itemType: itemType } );
        // toast.success( `${items.length} item(s) have been added!'`, { theme: 'dark' } );
        // close();
    }

    const create = async () => {
        const resp = await cl( { aid: viewing[0], uid: uid, name: search, items: items, itemType: itemType } );
        // toast.success( search + ' successfully created and added to!', { theme: 'dark' } );
        setSearch( '' );
        // close();
    }

    const trash = async ( gid ) => {
        const removed = await removeItem( { aid: aid, uid: uid, items: items, gid: gid } );
        
        if ( removed.length ) {
            // toast.success( `${removed.length} items(s) have been removed!'`, { theme: 'dark' } );
        } else {
            console.log( removed );
        }
    };

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '450px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    useEffect( () => {
        let listNames = [];
        Object.keys( lists ).forEach( gid => {
            const l = lists[gid];
            if ( viewing.includes( l.aid ) ) {
                if ( l.itemType === itemType ) {
                    listNames.push( l );
                }
            }
        } );

        let current = [];
        if ( items && items.length === 1 ) {
            const i = ( itemType === 'contacts' ) ? allContacts[items[0]] : allLoans[items[0]];
            if ( i ) {
                Object.keys( lists ).forEach( f => {
                    const list = lists[f];
                    if ( list.items?.includes( ( itemType === 'contacts' ) ? i.cid : i.lid ) ) {
                        current.push( list.label );
                    }
                })
            }
        }
        
        const l = listNames.filter( f => {
            if ( search === '' ) {
                return true;
            }
            
            if ( f.label && f.label.toLowerCase().includes( search.toLowerCase() ) ) {
                return true;
            }
        
            return false;
        } );
        
        setCurLists( current );
        setGlist( [ ...l ] );
    }, [ search, lists, items, allContacts, allLoans, viewing, itemType ] );

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Add to a List</Col>
                </Row>
                <Row className='pt-2'>
                    <Col>Good for you!  Let's do something with { items.length > 1 ? 'these' : 'this' } { items.length } contact...</Col>
                </Row>
                <Row className='py-3'>
                    <Col><Form.Control className='tf-modal-text-input' type="text" placeholder="Add To or Create a List..." value={search} onChange={filterGroup} /></Col>
                    { glist.length === 0 ? (
                        <Col xs='auto'>
                            <Button size='sm' variant='outline-primary' onClick={ () => create() }>Create</Button>
                        </Col>
                    ) : (
                        <Fragment />
                    ) }
                </Row>
                <Row>
                    <Col>
                        <ListGroup variant='flush' className='overflow-scroll' style={ { maxHeight: '65vh' }}>
                        {
                            glist.map( ( g, idx ) => ( 
                                <ListGroup.Item key={idx}>
                                    <Row className='tf-modal-list-item align-items-center'>
                                        <Col>{g.label}</Col>
                                        <Col xs='auto'>
                                            {
                                                curLists.includes( g.label ) ? (
                                                    <Button size='sm' variant='outline-primary' onClick={ () => trash( g.gid ) }>- Remove</Button>
                                                ) : (
                                                    <Button size='sm' variant='outline-primary' onClick={ () => add( g.gid ) }>+ Add</Button>
                                                )
                                            }
                                        </Col>
                                    </Row>
                                </ListGroup.Item> 
                            ) )
                        }
                        </ListGroup>
                    </Col>
                </Row>
            </Box>
            <ToastContainer autoClose={3000} />
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    uid: state.user.email,
    viewing: state.user.viewing,
    lists: state.lists.byId,
    allContacts: state.contacts.byId,
    allLoans: state.loans.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
    removeItem: dispatch.lists.removeItem,
    aitl: dispatch.lists.addItemsToLists,
    cl: dispatch.lists.createList
} );
  
export default connect( mapProps, mapDispatch )( AddToGroup );